import { useContext, useState } from "react";
import { getUsers } from "../../../users/functions";
import ToastContext from "../../../../context/toastProvider";
import Button from "../../../atoms/button";
import Loading from "../../../atoms/loading";
import { cpfMask, phoneMask } from "../../../utils/functions";
import RegisterModal from "../../../users/registerModal";
import SearchInput from "../../../filters/SearchInput";

const UserStep = ({ user, setUserData, setStep }) => {

    const { badToast } = useContext(ToastContext);

    const [loading, setLoading] = useState(false);
    const [q, setQ] = useState("");

    const [users, setUsers] = useState(null);
    const [selectedUser, setSelectedUser] = useState(null);

    const [create, setCreate] = useState(false);

    const handleSearch = async () => {
        setLoading(true);
        setSelectedUser(null);
        const data = await getUsers(user.token, "", "", "", "", false, false, q.trim() || undefined);

        if (data?.type !== "success") {
            badToast(data?.message);
            setLoading(false);
            return null;
        }
        setUsers(data?.data);
        setLoading(false);
    }

    const handleNext = () => {
        if (!selectedUser) {
            return null;
        }
        setUserData(selectedUser);
        setStep(1);
    }

    const handleUser = (data) => {
        setUserData(data);
        setStep(1);
    }

    const handleSelectUser = (u) => {
        if (selectedUser === u) {
            return setSelectedUser(null);
        }
        setSelectedUser(u);
    }

    return (
        <div className="relative">
            <p className="mb-3 text-sm text-laranjinha/60">Busque o cliente do pedido ou cadastre um novo.</p>
            <div className="flex flex-wrap items-center gap-2">
                <SearchInput
                    value={q}
                    onChange={setQ}
                    onSearch={handleSearch}
                    onClear={() => setQ("")}
                    placeholder="Buscar por nome, e-mail, CPF ou telefone…"
                />
                <Button click={() => setCreate(true)} classes="bg-blue-500 hover:bg-blue-300 inline whitespace-nowrap">Cadastrar novo</Button>
            </div>

            {
                users !== null ? (
                    <p className="mt-3 text-xs text-laranjinha/50">
                        {users.length === 0 ? "Nenhum cliente encontrado — refine a busca ou cadastre um novo." : users.length === 1 ? "1 cliente encontrado" : `${users.length} clientes encontrados`}
                    </p>
                ) : null
            }

            <div role="radiogroup" aria-label="Resultados da busca de cliente" className="mt-2 flex max-h-[400px] flex-col gap-2 overflow-y-auto">
                {
                    users?.map((u, i) => {
                        const selected = selectedUser === u;
                        return (
                            <button
                                type="button"
                                role="radio"
                                aria-checked={selected}
                                onClick={() => handleSelectUser(u)}
                                key={u?._id ?? i}
                                className={`flex items-center gap-3 rounded-lg border px-3 py-2 text-left transition ${
                                    selected ? "border-primary bg-mgs-elevated" : "border-primary/25 bg-mgs-surface/60 hover:border-primary/60"
                                }`}
                            >
                                <span
                                    aria-hidden="true"
                                    className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${selected ? "border-primary" : "border-primary/40"}`}
                                >
                                    {selected ? <span className="h-2 w-2 rounded-full bg-primary"></span> : null}
                                </span>
                                <span className="min-w-0">
                                    <span className="block truncate font-medium text-laranjinha">{u?.name}</span>
                                    <span className="block truncate text-xs text-laranjinha/60">
                                        {u?.email} · Tel: {phoneMask(u?.phone)} · Doc: {u?.documentType === "CPF" ? cpfMask(u?.documentNumber) : u?.documentNumber}
                                    </span>
                                </span>
                            </button>
                        );
                    })
                }
            </div>
            {
                users?.length ?
                    <Button click={handleNext} classes="bg-green-400 hover:bg-green-300 mt-4 px-6" disabled={!selectedUser}>Avançar →</Button>
                    : null
            }
            {/* LOADING OVERLAY */}
            {
                loading ?
                    <div className="absolute top-0 left-0 w-full h-full bg-[#000000dd] flex justify-center items-center">
                        <Loading />
                    </div>
                    : null
            }
            {
                create ?
                    <RegisterModal handleClose={() => setCreate(false)} productCreation={true} handleUser={handleUser} />
                    : null
            }
        </div>
    )
}

export default UserStep;
